import { getStoreId } from "$/hooks/use-store-information"
import serviceReminderQueries from "$/lib/queries/service-reminder-queries"
import { requireStoreFeature } from "$/lib/require-store-feature"
import { STORE_FEATURE } from "@repo/common"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/service-reminders")(
  {
    loader: async ({ context: { queryClient } }) => {
      await requireStoreFeature(queryClient, STORE_FEATURE.SERVICE_REMINDERS)
      const storeId = await getStoreId()
      if (storeId) {
        queryClient.prefetchQuery(serviceReminderQueries.settings(storeId))
      }
      return {
        crumb: "alfred.settings.nav.serviceReminders.label",
      }
    },
  },
)
